const { createSlice } = require('@reduxjs/toolkit');

const newOnboardingSlice = createSlice({
  name: 'newOnboarding',
  initialState: {
    hasCompletedNewOnboarding: false,
    onboardingData: null,
  },
  reducers: {
    setOnboardingCompleted(state, { payload }) {
      state.hasCompletedNewOnboarding = true;
      state.onboardingData = payload;
    },
    resetNewOnboarding(state) {
      state.hasCompletedNewOnboarding = false;
      state.onboardingData = null;
    },
  },
});

// Selectors
export const getHasCompletedNewOnboarding = (state) =>
  state?.newOnboarding?.hasCompletedNewOnboarding;

export const getNewOnboardingData = (state) =>
  state?.newOnboarding?.onboardingData;

// Actions
export const { setOnboardingCompleted, resetNewOnboarding } = newOnboardingSlice.actions;

// Reducer
export default newOnboardingSlice.reducer;
